<div class="tagged-photo">
  <div class="tagged-photo__banner">
    {{ banner() }} · Ch {{ photo()?.channel ?? '—' }}
    <ng-container *ngIf="photo()?.timestamp as ts">
      · {{ ts | date:'shortTime' }}
    </ng-container>
  </div>

  <div class="tagged-photo__frame">
    <img *ngIf="photo()?.url as src" [src]="src" alt="Channel {{ photo()?.channel }} {{ direction() }}" />

    <div *ngIf="!photo()?.url" class="tagged-photo__empty">
      No camera frame for this channel at this stop
    </div>

    @if (photo()?.url) {
      @for (tag of renderedTags(); track tag.seatNumber) {
        <div
          class="tagged-photo__tag"
          [class.tagged-photo__tag--muted]="tag.muted"
          [style.left]="tag.style['left']"
          [style.top]="tag.style['top']"
          [style.width]="tag.style['width']"
          [style.background]="tag.style['background']"
        >
          <span class="tagged-photo__tag-label">{{ tag.seatNumber }}</span>
        </div>
      }
    }
  </div>
</div>
